import React from 'react';
import classNames from 'classnames';

import { ClassNamesProps } from '~/models/ClassNamesProps';
import { IconCircleCheck, IconError, IconInformation } from '~/vinovest-design-system/components/Icons';

interface AlertProps extends ClassNamesProps {
    type: 'error' | 'success' | 'warning';
}

/** Banner alerts used within a form */
export const Alert: React.FC<AlertProps> = ({ children, type, classnames }) => {
    return (
        <div className={classNames('font-medium text-16 px-4 py-6 rounded flex', alertTheme[type], [classnames])}>
            <div>{alertIcon[type]}</div>
            {children}
        </div>
    );
};

/** Small, tooltip-like input alert. */
export const TooltipAlert: React.FC<AlertProps> = ({ children, type, classnames }) => {
    return (
        <p
            className={classNames(
                'lg:absolute font-medium text-14 rounded lg:shadow-2xl z-10 right-0 p-3 min-w-[200px]',
                alertTheme[type],
                [classnames]
            )}
        >
            {children}
        </p>
    );
};

const alertTheme = {
    error: 'text-red-600 bg-red-50',
    success: 'text-green-700 bg-green-50',
    warning: 'text-yellow-700 bg-yellow-50'
};

const alertIcon = {
    error: <IconError height={'24px'} width={'24px'} className={'mr-2'} />,
    warning: <IconInformation height={'24px'} width={'24px'} className={'mr-2'} stroke={'#a16207'} />,
    success: <IconCircleCheck className={'h-5 w-5 text-green-400 mr-2'} />
};
